import { fetchAuthSession } from 'aws-amplify/auth';
import AWS from 'aws-sdk';

 // Initialize AWS Cognito Identity pool or STS with the provided auth token
 const initAWSTemporaryCredentials = async (): Promise<AWS.CognitoIdentityCredentials> => {
    try {
      console.log('Fetching auth session...');
      // Fetch session and tokens
      const { tokens } = await fetchAuthSession();
      
      // Ensure we are using the ID token for authentication
      const idToken = tokens?.idToken?.toString(); 
      console.log('ID token obtained:', idToken ? 'Yes' : 'No');
      
      if (!idToken) {
        throw new Error('Invalid ID token');
      }
  
      console.log('Initializing Cognito credentials...');
      // Initialize Cognito credentials
      const credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: 'ap-southeast-2:7819ca54-270c-45db-93f1-0d9f1e89afb8',
        Logins: {
          'cognito-idp.ap-southeast-2.amazonaws.com/ap-southeast-2_4RZ7iI5f7': idToken,
        },
      });
  
      // Return a promise that resolves when credentials are ready
      return new Promise((resolve, reject) => {
        credentials.get((err) => {
          if (err) {
            console.error('Error getting credentials:', err);
            reject(err);
          } else {
            console.log('Credentials obtained successfully');
            resolve(credentials);
          }
        });
      });
    } catch (error) {
      console.error('Error initializing AWS credentials:', error);
      throw error;
    }
  };

  export default initAWSTemporaryCredentials